export const PRL_FLOW_TYPE = "prl";
export const PRODUCT_FLOW_TYPE = "product";
export const COMPANY_FLOW_TYPE = "merchant";
export const DRAWER_FLOW_TYPE = "drawer";
export const CUSTOMER_FLOW_TYPE = "customer";
